import { ga4Mapper } from '../ga4-mapper'

export const bookingLuggageSwitchMapper = (data) => {
  let dataObject = null
  if (data && data.serviceName) {
    const serviceName = data.serviceName || ''
    const result = data.choosePerPersonIsChecked ? 'element selected' : 'element unselected'

    dataObject = ga4Mapper({
      event: 'Ancillaries',
      description: data.description,
      element: 'switch',
      type: serviceName,
      result,
      interaction: true
    })
  }
  return dataObject
}
